//
// Copyright 2026 DXOS.org
//

import { lazy } from 'react';

export const AgentHaloArticle = lazy(() => import('./AgentHaloArticle/index.ts'));
